"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Column_1 = __importDefault(require("./Column"));
var style_1 = require("./style");
var FooterContent = function (_a) {
    var columns = _a.columns;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement("div", { className: 'FooterContent__columnsWrapper' }, columns.map(function (column) { return (react_1.default.createElement(Column_1.default, { items: column.items, key: column.title, nbColumns: columns.length, title: column.title })); }))));
};
exports.default = FooterContent;
